import React from 'react';
import Navbar from '../components/common/Navbar';
import SidebarComp from '../components/common/Sidebar';

function Home() {

  return (
    <>
      <Navbar />
      <SidebarComp />
    </>
  );
}

export default Home;